import { useResponsiveValue } from 'dripsy';

export function useHorizontalTabView() {
  const tutorialItemWidth = useResponsiveValue([253, 287]);
  const trackItemWidth = useResponsiveValue([141, 184]);

  return {
    tutorialItemWidth,
    trackItemWidth,
  };
}
